import React from 'react';
import PropTypes from 'prop-types';

import Maybe from 'react-maybe';
import { FileView, NoFiles } from '..';

const Files = ({ form, translations }) => {
    const files = [...form.cvFiles.value, ...form.customFiles];
    const filesFiltered = files.filter((file) => file.fileId);

    return (
        <Maybe
            of={Boolean(filesFiltered.length)}
            either={files.map((file, index) => (
                <FileView key={`${file.size}__${index}`} file={file} />
            ))}
            orElse={<NoFiles />}
        />
    );
};
Files.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};
export default Files;
